module.exports = __webpack_public_path__ + "static/media/media6.4123c3a6.png";